module.exports = __webpack_public_path__ + "img/CL_OUTGOING_GOODS_2.ad21c293.png";